module.exports = __webpack_public_path__ + "static/media/generate.79eb9dff.svg";